import React from 'react'
import { DetailsRow, TitleBar } from 'components/Shared/CrudComponents'
import { Loader } from 'components/Shared/Loader'
import { toDisplayDateTime } from 'utils/date'
import TextField from '@material-ui/core/TextField'
import styles from './ContractorEditHistory.module.css'
import { ReactComponent as DropdownIcon } from 'assets/icons/dropdown.svg'
import { Autocomplete } from '@material-ui/lab'
import { useTranslation } from 'react-i18next'
import { ContractorBasicDetails } from './ContractorBasicDetails'
import { ContractorCompanyAddress } from './ContractorCompanyAddress'
import { ContractorCorrespondenceAddress } from './ContractorCorrespondenceAddress'
import { ContractorAdditionalDetails } from './ContractorAdditionalDetails'
import { useContractorUpdateHistory } from 'components/Contractors/Details/hooks'
import { useHistory, useLocation } from 'react-router-dom'
import { ContractorFiles } from './ContractorFiles'
import {
  CONTRACTOR_ADDITIONAL_DATA_READ,
  CONTRACTOR_ADDRESS_READ,
  CONTRACTOR_ATTACHMENTS_READ,
  CONTRACTOR_CORRESPONDENCE_READ,
  CONTRACTOR_DATA_READ,
  useAuth
} from 'context/auth'

export const ContractorEditHistory = (props) => {
  const history = useHistory()
  const location = useLocation()

  const setPreviewedVersion = (version) => {
    const searchParams = new URLSearchParams(location.search)
    searchParams.set('version', version)
    history.replace({
      pathname: location.pathname,
      search: '?' + searchParams.toString()
    })
  }

  const previewedVersion = parseInt(new URLSearchParams(location.search).get('version')) || 1

  const { t } = useTranslation()
  const { hasAnyPrivileges } = useAuth()

  const contractorId = props.match.params.contractorId

  const { updateHistory, updateHistoryLoading } = useContractorUpdateHistory(contractorId)

  if (updateHistoryLoading) {
    return <Loader/>
  }

  if (!updateHistory) {
    return null
  }

  const latestRecord = updateHistory[updateHistory.length - 1]
  const selectedRecord = updateHistory.find(it => it.version === previewedVersion)
  const previousRecord = updateHistory.find(it => it.version === previewedVersion - 1)

  const renderTitle = () => {
    return (
      <>
        <h1>{latestRecord.fullName}</h1>
        <Autocomplete
          options={updateHistory}
          id="contractorVersionSelect"
          disableClearable
          getOptionLabel={option => t('contractor.editHistory.recordLabel', {
            version: option.version,
            dateTime: toDisplayDateTime(option.updateDateTime)
          })}
          value={selectedRecord}
          onChange={(e, selectedOption) => setPreviewedVersion(selectedOption.version)}
          renderInput={params => (
            <TextField
              {...params}
              label={t('contractor.editHistory.selectVersion')}
              variant="filled"
              fullWidth
              InputProps={{ ...params.InputProps, disableUnderline: true }}
              className={styles.versionSelect}
            />
          )}
          popupIcon={<DropdownIcon/>}
        />
      </>
    )
  }

  return (
    <>
      <TitleBar
        renderButton={() => null}
        renderTitle={renderTitle}
      />
      <DetailsRow>
        <ContractorBasicDetails contractor={selectedRecord} previousContractor={previousRecord}
                                showCustomFields={false} visible={hasAnyPrivileges([CONTRACTOR_DATA_READ])}/>
        <ContractorCompanyAddress contractor={selectedRecord} previousContractor={previousRecord}
                                  showCustomFields={false} visible={hasAnyPrivileges([CONTRACTOR_ADDRESS_READ])}/>
        <ContractorCorrespondenceAddress contractor={selectedRecord} previousContractor={previousRecord}
                                         showCustomFields={false}
                                         visible={hasAnyPrivileges([CONTRACTOR_CORRESPONDENCE_READ])}/>
        <ContractorAdditionalDetails contractor={selectedRecord} previousContractor={previousRecord}
                                     showCustomFields={false}
                                     visible={hasAnyPrivileges([CONTRACTOR_ADDITIONAL_DATA_READ])}/>
        <ContractorFiles contractor={selectedRecord} previousContractor={previousRecord}
                         showCustomFields={false} visible={hasAnyPrivileges([CONTRACTOR_ATTACHMENTS_READ])}/>
      </DetailsRow>
    </>
  )
}